import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import { TriggerContext } from '../../utils/Trigger';
function useKeep(event) {
    var e = event;
    if (!e._dui_bypass_dropdown_keep) {
        e._dui_dropdown_keep = true;
    }
}
var Keep = (function (_super) {
    __extends(Keep, _super);
    function Keep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMouseUp = function (e) {
            setTimeout(function () {
                _this.context(false);
            }, 0);
        };
        _this.handleClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled;
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            var event = e.nativeEvent;
            if (disabled === true ||
                (typeof disabled === 'function' && disabled(e)) ||
                event._dui_bypass_dropdown_keep) {
                return;
            }
            event._dui_dropdown_keep = true;
        };
        _this.handleMouseDown = function (e) {
            _this.context(true);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, disabled = _a.disabled, domRef = _a.domRef, rest = __rest(_a, ["prefixCls", "className", "style", "children", "disabled", "domRef"]);
            var cls = classNames(prefixCls, className);
            return (h("div", __assign({}, rest, { className: cls, style: style, ref: domRef, onClick: _this.handleClick, onMouseDown: _this.handleMouseDown }), children));
        };
        return _this;
    }
    Keep.prototype.componentDidMount = function () {
        document.addEventListener('mouseup', this.handleMouseUp);
    };
    Keep.prototype.componentWillUnmount = function () {
        document.removeEventListener('mouseup', this.handleMouseUp);
    };
    Keep.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Keep.contextType = TriggerContext;
    Keep.useKeep = useKeep;
    return Keep;
}(React.Component));
export default Keep;
Keep.defaultProps = {
    prefixCls: 'dui-dropdown-keep',
    disabled: false
};
